export default __webpack_public_path__ + "static/media/Expert.6f0f7d17.png";